import React, { useState } from 'react';
import ProductSubCategoryDetailsFields from './ProductSubCategoryDetailsFields';

function EditProductSubCategory({ SubCategoryData, sendDataToParent }) {
  const [slugManual, setSlugManual] = useState(true);

  const handleData = (data) => {
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductSubCategoryDetailsFields
        formData={SubCategoryData}
        sendDataToParent={handleData}
        slugManual={slugManual}
        onSlugManualChange={setSlugManual}
      />
    </div>
  );
}

export default EditProductSubCategory;
